export const CDP_PATHS = {
  REGISTRATIONS: "/cdp/registrations",
  DEMOGRAPHICS: "/cdp/registrations/demographics",
  TRANSACTIONS: "/cdp/subscription/transactions",
  METRICS: "/cdp/subscription/metrics",
  ANALYTICS: "/cdp/subscription-analytics",
  ANONYMOUS: "/cdp/anonymous",
  ANONYMOUS_REGISTERED: "/cdp/anonymous/registered",
  ANONYMOUS_CATEGORIES: "/cdp/anonymous/categories",
  ANONYMOUS_ARTICLES: "/cdp/anonymous/articles",
};

export const getEmptyDateRange = () => ({ startDate: null, endDate: null });
export const EMPTY_DATE_RANGE = getEmptyDateRange();

export const ANALYTICS_COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042"];
